import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(id, logo) {
  return yield oncallFetch("/api/oncall/administration/partners/change-logo", {
    id,
    logo,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/partners/upload-logo.js